import UploadFile from "@mui/icons-material/UploadFile";
import { Box, Grid, Stack } from "@mui/material";
import ColorLibraryIcon from "./../../asset/colorlibrary.svg";
import ColorLibraryHighlightIcon from "./../../asset/colorlibraryhighlight.svg";
import { useEffect, useState } from "react";
import { DropzoneArea } from "../common/dropZone";
import { useStoreState, useStoreActions } from "easy-peasy";
import InputColorLibrary from "./colorLibrary";
import { findInputColorsRTCurveValues } from "../../utils/xmlParser";
const textCss = {
  fontSize: "16px",
  fontFamily: "Source Sans Pro",
  fontWeight: "600",
  lineHeight: "24px",
  wordWrap: "break-word",
};
const highlightCss = {
  width: "65%",
  padding: "24px",
  background: "rgba(55, 147, 213, 0.12)",
  borderRadius: "8px",
  border: "1px #385DAE solid",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: "8px",
  display: "inline-flex",
  color: "#385DAE",
  cursor: "pointer",
};

const notHighlightCss = {
  width: "65%",
  padding: "24px",
  background: "white",
  borderRadius: "8px",
  border: "1px #C7C9C7 solid",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: "8px",
  display: "inline-flex",
  color: "#303C43",

  cursor: "pointer",
};
export const InputColor = () => {
  useEffect(() => {
    setNextBtnDisabled(true);
  }, []);

  const [selectedInput, setSelectedInput] = useState("upload");
  let inputColor = useStoreState((state) => state.inputColor);
  let setInputColor = useStoreActions((actions) => actions.setInputColor);
  const setNextBtnDisabled = useStoreActions(
    (actions) => actions.setNextBtnDisabled
  );

  const handleClick = (type) => {
    setSelectedInput(type);
  };

  //  this called when we upload file in dropzone
  //  - read the cxf file then it will convert xml to JSON then we can read easily
  //  - read the reflectance and transmittance (RT) curve from the file
  //  -  before saving the RT curve into state it will pass from validation if validation pass will save in state otherwise error in console.log()
  const handleUploadFile = (xmlJson, fileName) => {
    let data = findInputColorsRTCurveValues(xmlJson);
    if (data != -1) {
      setInputColor({ uploadedColorArray: data, fileName });
      setNextBtnDisabled(false);
    } else {
      setNextBtnDisabled(true);
      setInputColor({ uploadedColorArray: [], fileName: "" });
      // show correct validation message on invalid file format
      console.log("Invalid File Format");
      // disbale upload button
    }
  };

  //  when we click on cross arrow button this function will trigger to reset the state
  const handleRemoveFile = () => {
    setNextBtnDisabled(true);
    setInputColor({ uploadedColorArray: [], fileName: "" });
  };

  return (
    <Box>
      <Grid container spacing={2} sx={{ mt: "40px", mb: 10 }}>
        {/* Code hide as not part of phase 1 according to the new figma design */}
        {/* <Grid xs={6}>
          <Box className="font-22 font-weight-600 line-height-32  black-heading font-family">
            {' '}
            Select a color input method{' '}
          </Box>
        </Grid> 
        <Grid xs={6}></Grid>

        <Grid container xs={12} sx={{ mt: '24px' }}>
          <Grid xs={3}>
            {' '}
            <Box
              sx={selectedInput == 'upload' ? highlightCss : notHighlightCss}
              onClick={() => handleClick('upload')}
            >
              <UploadFile
                sx={{
                  color: selectedInput == 'upload' ? '#385DAE' : '#858585',
                }}
              />
              <Box sx={textCss}>Upload File</Box>
            </Box>
          </Grid>

          <Grid xs={3}>
            <Box
              sx={selectedInput == 'color' ? highlightCss : notHighlightCss}
              onClick={() => handleClick('color')}
            >
              <img
                src={
                  selectedInput == 'color'
                    ? ColorLibraryHighlightIcon
                    : ColorLibraryIcon
                }
              />
              <Box sx={textCss}>Color Library</Box>
            </Box>
          </Grid>
          <Grid xs={6}></Grid>
        </Grid> */}

        <Grid xs={12} sx={{ mt: "12px" }}>
          {selectedInput == "upload" ? (
            <DropzoneArea
              handleUploadFile={handleUploadFile}
              fileName={inputColor.fileName}
              handleRemoveFile={handleRemoveFile}
              noOfColorPoints={inputColor.uploadedColorArray.length}
              dialogNames="inputColor"
            />
          ) : (
            ""
          )}
        </Grid>

        {/* <Grid xs={12} sx={{ mt: '24px' }}>
          {selectedInput == 'color' ? <InputColorLibrary /> : ''}
        </Grid> */}
      </Grid>
    </Box>
  );
};
